module.exports = __webpack_public_path__ + "img/eg.egfd860b7.svg";